(function () {
  'use strict';

  function initSecAnnBar(wrapperEl) {
    if (wrapperEl._secAnnDestroy) {
      wrapperEl._secAnnDestroy();
    }

    var mobileEl = wrapperEl.querySelector('.sec-ann-bar__mobile');
    if (!mobileEl) return;

    var track = mobileEl.querySelector('.sec-ann-bar__track');
    if (!track) return;

    var autoRotate = wrapperEl.dataset.autoRotate === 'true';
    var speed = parseInt(wrapperEl.dataset.speed, 10) || 4000;
    var timer = null;
    var busy = false;
    var current = 1;

    // Klone eines vorherigen Init IMMER zuerst entfernen (auch im Static-Modus).
    Array.prototype.forEach.call(
      track.querySelectorAll('.sec-ann-bar__clone'),
      function (c) { c.parentNode.removeChild(c); }
    );

    // Nur die tatsaechlich sichtbaren Slides zaehlen.
    // Versteckte Review-Slides sind per CSS display:none und belegen keinen Slot mehr.
    var realSlides = Array.prototype.filter.call(
      track.querySelectorAll('.sec-ann-bar__slide'),
      function (s) { return !s.classList.contains('sec-ann-bar__review--hidden'); }
    );

    function getTotal() {
      return track.querySelectorAll('.sec-ann-bar__slide:not(.sec-ann-bar__review--hidden)').length;
    }

    function jumpTo(index) {
      track.style.transition = 'none';
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      current = index;
      track.getBoundingClientRect();
    }

    function slideTo(index) {
      track.style.transition = 'transform 0.4s ease';
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      current = index;
    }

    function onTransitionEnd() {
      var total = getTotal();
      if (current >= total - 1) {
        jumpTo(1);
      } else if (current <= 0) {
        jumpTo(total - 2);
      }
      busy = false;
    }

    function next() {
      if (busy) return;
      busy = true;
      slideTo(current + 1);
    }

    function prev() {
      if (busy) return;
      busy = true;
      slideTo(current - 1);
    }

    function startAuto() {
      if (!autoRotate) return;
      stopAuto();
      timer = setInterval(next, speed);
    }

    function stopAuto() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // ------------------------------------------------------------------
    // Auto-Rotate AUS: kein Slider, sondern statisch das Trusted-Shops-
    // Element anzeigen. Ist es (noch) nicht sichtbar - z.B. weil die
    // Trusted-Shops-Daten noch laden oder der Abruf fehlgeschlagen ist -
    // faellt es auf den ersten sichtbaren Slide zurueck. Sobald die Daten
    // da sind, ruft applyTrustedShopsStats() initSecAnnBar() erneut auf
    // und es wird auf das Review-Element umgeschaltet.
    // ------------------------------------------------------------------
    if (!autoRotate) {
      var reviewIndex = -1;
      for (var i = 0; i < realSlides.length; i++) {
        if (realSlides[i].querySelector('.sec-ann-bar__review')) {
          reviewIndex = i;
          break;
        }
      }
      jumpTo(reviewIndex > -1 ? reviewIndex : 0);
      return;
    }

    if (realSlides.length <= 1) {
      jumpTo(0);
      return;
    }

    track.addEventListener('transitionend', onTransitionEnd);

    var firstClone = realSlides[0].cloneNode(true);
    var lastClone = realSlides[realSlides.length - 1].cloneNode(true);
    firstClone.classList.add('sec-ann-bar__clone');
    lastClone.classList.add('sec-ann-bar__clone');
    track.appendChild(firstClone);
    track.insertBefore(lastClone, track.firstChild);

    jumpTo(1);
    startAuto();

    var touchStartX = 0;
    var touchMoved = false;

    function onTouchStart(e) {
      touchStartX = e.changedTouches[0].clientX;
      touchMoved = false;
    }

    function onTouchEnd(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        touchMoved = true;
        stopAuto();
        if (busy) {
          track.style.transition = 'none';
          busy = false;
        }
        if (diff > 0) { next(); } else { prev(); }
        setTimeout(startAuto, speed);
      }
    }

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchend', onTouchEnd, { passive: true });
    mobileEl.addEventListener('mouseenter', stopAuto);
    mobileEl.addEventListener('mouseleave', startAuto);

    wrapperEl._secAnnDestroy = function () {
      stopAuto();
      track.removeEventListener('transitionend', onTransitionEnd);
      track.removeEventListener('touchstart', onTouchStart);
      track.removeEventListener('touchend', onTouchEnd);
      mobileEl.removeEventListener('mouseenter', stopAuto);
      mobileEl.removeEventListener('mouseleave', startAuto);
      wrapperEl._secAnnDestroy = null;
    };
  }

  var TS_ID = 'X550BE1AC4263EC2C7B72DE4C29E61E73';
  var TS_PROFILE_URL = 'https://www.trustedshops.de/bewertung/info_' + TS_ID + '.html';
  var TS_CACHE_KEY = 'sec-ann-ts-stats-v1';
  var TS_CACHE_TTL_MS = 60 * 60 * 1000;

  function fetchTrustedShopsData(sectionEl) {
    var reviewEls = sectionEl.querySelectorAll('[data-ts-review]');
    if (!reviewEls.length) return;

    loadTrustedShopsStats()
      .then(function (stats) {
        applyTrustedShopsStats(sectionEl, reviewEls, stats);
      })
      .catch(function () {});
  }

  function loadTrustedShopsStats() {
    var cached = readTsCache();
    if (cached) return Promise.resolve(cached);

    return fetch(TS_PROFILE_URL)
      .then(function (res) {
        if (!res.ok) throw new Error('profile fetch failed');
        return res.text();
      })
      .then(function (html) {
        var stats = parsePublicProfileStats(html);
        if (!stats) throw new Error('profile parse failed');
        writeTsCache(stats);
        return stats;
      });
  }

  function parsePublicProfileStats(html) {
    // Same reviewStatistic object rendered on the public Trusted Shops profile.
    var match = html.match(/\\?"reviewStatistic\\?":\s*(\{[^}]+\})/);
    if (!match) return null;

    try {
      var json = match[1].replace(/\\"/g, '"').replace(/\\u0026/g, '&');
      var stats = JSON.parse(json);
      var totalCount = Number(stats.allTimeReviewCount);
      var average = Number(stats.grade);
      if (!totalCount || !average) return null;

      return {
        totalCount: totalCount,
        yearlyCount: Number(stats.yearlyReviewCount) || 0,
        average: average
      };
    } catch (e) {
      return null;
    }
  }

  function readTsCache() {
    try {
      var raw = sessionStorage.getItem(TS_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.expiresAt || Date.now() > parsed.expiresAt) return null;
      if (!parsed.totalCount || !parsed.average) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeTsCache(stats) {
    try {
      sessionStorage.setItem(TS_CACHE_KEY, JSON.stringify({
        totalCount: stats.totalCount,
        yearlyCount: stats.yearlyCount,
        average: stats.average,
        expiresAt: Date.now() + TS_CACHE_TTL_MS
      }));
    } catch (e) {}
  }

  function applyTrustedShopsStats(sectionEl, reviewEls, stats) {
    var rawAverage = Number(stats.average) || 0;
    var roundedAverage = normalizeAverageRating(rawAverage);
    var reviewCount = Number(stats.totalCount) || 0;

    reviewEls.forEach(function (el) {
      var starMode = el.dataset.ratingMode;
      var labelMode = el.dataset.labelMode || 'count';
      var countEl = el.querySelector('[data-ts-count]');
      var starsEl = el.querySelector('[data-ts-stars]');

      // --- Sterne ---
      // Legacy-Wert 'api_total' faellt bewusst auf den echten Durchschnitt zurueck.
      var starValue = starMode === 'api_average_rounded' ? roundedAverage : rawAverage;
      if (starsEl) renderStars(starsEl, starValue);

      // --- Text in Klammern (unabhaengig von der Sterne-Quelle) ---
      if (countEl) {
        var countText = reviewCount.toLocaleString('de-DE');
        var label = '';
        if (labelMode === 'count') {
          label = countText;
        } else if (labelMode === 'average') {
          label = formatAverage(rawAverage, 2);
        } else if (labelMode === 'average_count') {
          label = formatAverage(rawAverage, 2) + ' · ' + countText;
        }
        countEl.textContent = label ? '(' + label + ')' : '';
      }

      el.classList.remove('sec-ann-bar__review--hidden');
    });

    initSecAnnBar(sectionEl);
  }

  function normalizeAverageRating(value) {
    // Immer auf die naechsthoehere Zehntelstelle: 4,42 -> 4,5 | 4,51 -> 4,6
    var scaled = (Number(value) || 0) * 10;
    var snapped = Math.round(scaled);
    // Gleitkomma-Rauschen abfangen (4.7 * 10 === 47.00000000000001)
    if (Math.abs(scaled - snapped) < 1e-6) scaled = snapped;
    return Math.ceil(scaled) / 10;
  }

  function formatAverage(value, decimals) {
    var n = Number(value) || 0;
    var places = typeof decimals === 'number' ? decimals : 2;
    return n.toLocaleString('de-DE', {
      minimumFractionDigits: places,
      maximumFractionDigits: places
    });
  }

  var starPath = 'M8.52449 3.86088L6.76667 5.37768L7.30222 7.64604C7.33177 7.76918 7.32416 7.89831 7.28036 8.01713C7.23655 8.13594 7.15851 8.23911 7.0561 8.3136C6.95369 8.38809 6.8315 8.43055 6.70497 8.43563C6.57844 8.44071 6.45324 8.40817 6.34519 8.34213L4.37253 7.12807L2.39871 8.34213C2.29067 8.40779 2.16562 8.44002 2.03931 8.43475C1.91299 8.42949 1.79106 8.38697 1.68886 8.31254C1.58667 8.23812 1.50877 8.13512 1.465 8.01652C1.42122 7.89792 1.41351 7.76901 1.44285 7.64604L1.98035 5.37768L0.222534 3.86088C0.126948 3.77827 0.0578174 3.66933 0.0237774 3.54766C-0.0102626 3.42599 -0.00770393 3.29699 0.0311339 3.17677C0.0699717 3.05655 0.143367 2.95043 0.242155 2.87167C0.340942 2.79292 0.460743 2.74501 0.586597 2.73393L2.89128 2.54799L3.78035 0.39643C3.82847 0.279171 3.91037 0.178871 4.01565 0.108281C4.12092 0.037691 4.24481 0 4.37156 0C4.49831 0 4.62219 0.037691 4.72747 0.108281C4.83274 0.178871 4.91465 0.279171 4.96277 0.39643L5.85144 2.54799L8.15613 2.73393C8.28223 2.7446 8.40238 2.79224 8.50153 2.87089C8.60067 2.94953 8.67441 3.05569 8.71349 3.17606C8.75257 3.29643 8.75526 3.42565 8.72122 3.54754C8.68718 3.66943 8.61793 3.77857 8.52214 3.86127L8.52449 3.86088Z';

  function makeStarSvg(fillPercent, uid) {
    var id = 'sar-clip-' + uid;
    if (fillPercent >= 1) {
      return '<svg width="10" height="10" viewBox="0 0 8.74491 8.43615" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="' + starPath + '" fill="#171717"/></svg>';
    }
    if (fillPercent <= 0) {
      return '<svg width="10" height="10" viewBox="0 0 8.74491 8.43615" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="' + starPath + '" fill="#cccccc"/></svg>';
    }
    var clipW = (fillPercent * 8.74491).toFixed(3);
    return '<svg width="10" height="10" viewBox="0 0 8.74491 8.43615" fill="none" xmlns="http://www.w3.org/2000/svg">'
      + '<defs><clipPath id="' + id + '"><rect x="0" y="0" width="' + clipW + '" height="8.43615"/></clipPath></defs>'
      + '<path d="' + starPath + '" fill="#cccccc"/>'
      + '<path d="' + starPath + '" fill="#171717" clip-path="url(#' + id + ')"/>'
      + '</svg>';
  }

  var starUidCounter = 0;

  function renderStars(container, mark) {
    var totalStars = 5;
    // Eindeutiger ID-Praefix pro Aufruf. Desktop- und Mobile-Block rendern beide
    // 5 Sterne; bei gleichen clipPath-IDs zeigt der Teil-Stern im Mobile-Block auf
    // die clipPath im ausgeblendeten Desktop-Block, das Clipping greift nicht und
    // der Stern wird voll dargestellt (Symptom: 5 von 5 gefuellt).
    var uidBase = ++starUidCounter;
    var html = '';
    for (var i = 0; i < totalStars; i++) {
      var fill = Math.min(1, Math.max(0, mark - i));
      html += '<span class="sec-ann-bar__star">' + makeStarSvg(fill, uidBase + '-' + i) + '</span>';
    }
    container.innerHTML = html;
  }

  function init() {
    var sections = document.querySelectorAll('[data-sec-ann-bar]');
    sections.forEach(function (sectionEl) {
      initSecAnnBar(sectionEl);
      fetchTrustedShopsData(sectionEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var inner = e.target.querySelector('[data-sec-ann-bar]');
    if (inner) {
      initSecAnnBar(inner);
      fetchTrustedShopsData(inner);
    }
  });
})();
